export default "__VITE_ASSET__98fa3b20__"